import './styles/authentication.css'
import React, {useEffect, useState} from "react";
import { useNavigate } from 'react-router-dom';
import aes256 from 'aes256';
function Authentication() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();

    useEffect(()=>{
        localStorage.removeItem("email");
        fetch('https://taskmanagementbackend-810lxavxl-obaid-ur-rehmxn.vercel.app/api/start',{
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*'
            }
        })
        .then(res => res.json())
        .catch(err=>alert(err))
    },[]);

    function login(e){
        e.preventDefault();
        let cypher=aes256.createCipher(password);
        let user={
            email:email
        };
        fetch('https://taskmanagementbackend-810lxavxl-obaid-ur-rehmxn.vercel.app/api/login',{
            method: "POST",
            headers: {"Content-Type": "application/JSON",
                'Access-Control-Allow-Origin': '*'},
            body: JSON.stringify(user)
        })
        .then(res=>res.json())
        .then(data=>{if(data.password!=="User not found"){
            let decrypted = cypher.decrypt(data.password);
            if (decrypted===password){
                alert("User logged in");
                localStorage.setItem("email",email);
                navigate('/dashboard');
            }
            else{
                alert("Wrong password");
            }
        }
        else{
            alert("User not found");
        }
        }).catch(err=>alert(err));
    }

    function register(e){
        e.preventDefault();
        let cypher=aes256.createCipher(password);
        let encryptedPassword=cypher.encrypt(password);
        let user={
            email:email,
            password:encryptedPassword
        };
        fetch('https://taskmanagementbackend-810lxavxl-obaid-ur-rehmxn.vercel.app/api/register',{
            method: "POST",
            headers: {"Content-Type": "application/JSON",
                'Access-Control-Allow-Origin': '*'},
            body: JSON.stringify(user)
        })
            .then(res=>res.json())
            .then(data=>alert(data.data))
            .then(()=>navigate('/'))
            .catch(err=>alert(err));

    }

    return(
        <>
            <form>
                <h1>Authentication</h1>
                <div className="form_group">
                <input placeholder="Email" type="text" value={email} onChange={(e)=>setEmail(e.target.value)}/>
                <input placeholder="Password" type="text" value={password} onChange={(e)=>setPassword(e.target.value)}/>
                    <div className='buttons'>
                    <button onClick={login}>Sign In</button>
                    <button onClick={register}>Sign Up</button>
                    </div>
                </div>
            </form>
        </>
    )
}
export default Authentication;